import React from 'react';
import styled from '@emotion/styled';

interface Props {
  spacing: number;
}

const Column = styled('div')<Props>`
  display: grid;
  grid-gap: ${(props: Props) => props.spacing}px;
`;

export default React.memo(Column);
